// @ts-check
import React, { Component } from "react"
import AvailableBroadcast from "../broadcast/AvailableBroadcast"

/**
 * @augments {Component<{children: (props: Broadcastable[]) => any}>}
 */
class AvailableActions extends Component {
    render() {
        return (
            <AvailableBroadcast>
                {broadcast =>
                    this.props.children(broadcast.filter(({ channel }) => channel === "action"))
                }
            </AvailableBroadcast>
        )
    }
}

export default AvailableActions



// WEBPACK FOOTER //
// ./src/features/editor/actions/AvailableActions.js